import { Component, Input, HostBinding } from '@angular/core';
import { IccAppearance } from '../../enums/appearance';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'span[iccBadgeChip], p[iccBadgeChip]',
  templateUrl: './badge-chip.component.html',
  styleUrls: ['./badge-chip.component.scss']
})
export class BadgeChipComponent {

  @Input()
  @HostBinding('attr.data-appearance')
  appearance: IccAppearance | string = IccAppearance.Primary;
}
